import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm$partsByWine, _vm$partsByWine2, _vm$partsByWine3, _vm$entity$comment;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c(VDialog, {
    attrs: {
      width: "800",
      persistent: ""
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.close.apply(null, arguments);
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [!_vm.isAnyActionInProgress ? _c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle mt-1",
    on: {
      click: _vm.close
    }
  })], 1) : _vm._e(), _c(VCardTitle, {
    staticClass: "headline"
  }, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v("Domestic transfer")])]), _c("div", {
    staticClass: "content-centered large text-left"
  }, [_vm.isLoading ? _c("div", {
    staticClass: "text-center"
  }, [_c(VProgressCircular, {
    attrs: {
      indeterminate: "",
      size: "45",
      width: "3"
    }
  })], 1) : [_vm.entity ? [_c("div", {
    staticClass: "text-smaller"
  }, [_c("div", {
    staticClass: "mb-3"
  }, [_vm._v(" Reference : " + _vm._s(_vm.entity.reference) + " "), _vm.isEditable && !_vm.isAnyActionInProgress && !_vm.isAnySubformInProgress ? _c(VIcon, {
    staticClass: "fa fa-pen icon-link ml-2",
    staticStyle: {
      top: "-3px"
    },
    attrs: {
      size: "0.8em"
    },
    on: {
      click: _vm.startEditReference
    }
  }) : _vm._e(), _vm.updatingReference.isConfiguring ? _c("div", {
    staticClass: "subform-bordered"
  }, [_c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.updatingReference.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.updatingReference.form, "valid", $$v);
      },
      expression: "updatingReference.form.valid"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Reference",
      placeholder: "Transfer reference",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.updatingReference.form.reference,
      callback: function callback($$v) {
        _vm.$set(_vm.updatingReference.form, "reference", $$v);
      },
      expression: "updatingReference.form.reference"
    }
  }), _c("div", {
    staticClass: "mt-3 flex"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      rounded: ""
    },
    on: {
      click: _vm.cancelUpdatingReference
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-times mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Cancel ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: "",
      disabled: _vm.isAnyActionInProgress || !_vm.updatingReference.form.valid || _vm.updatingReference.form.reference === _vm.entity.reference,
      loading: _vm.updatingReference.isPending
    },
    on: {
      click: _vm.saveUpdatingReference
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-save mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Save reference ")], 1)], 1)], 1)], 1) : _vm._e(), _vm.isCancelled ? _c("div", {
    staticClass: "text-italic"
  }, [_vm._v(" Cancelled : " + _vm._s(_vm._f("formatDate_string")(_vm.entity.cancellation.date)) + " by " + _vm._s(_vm.getFullNameUser(_vm.entity.cancellation.user, false)) + " ")]) : _vm._e(), _vm.isDelivered ? _c("div", {
    staticClass: "text-italic"
  }, [_vm._v(" Delivered : (" + _vm._s(_vm._f("formatDate_string")(_vm.entity.delivery.date)) + ") by " + _vm._s(_vm.getFullNameUser(_vm.entity.delivery.user, false)) + " ")]) : _vm._e()], 1), ((_vm$partsByWine = _vm.partsByWine) === null || _vm$partsByWine === void 0 ? void 0 : _vm$partsByWine.length) > 0 ? _c("div", {
    staticClass: "mb-6 text-bigger"
  }, [_c("div", [_vm._v(" " + _vm._s((_vm$partsByWine2 = _vm.partsByWine) === null || _vm$partsByWine2 === void 0 ? void 0 : _vm$partsByWine2.length) + " Product " + _vm._s(((_vm$partsByWine3 = _vm.partsByWine) === null || _vm$partsByWine3 === void 0 ? void 0 : _vm$partsByWine3.length) > 1 ? "s" : "") + " transferred from " + _vm._s(_vm.entity.fromWarehouse.name) + " to " + _vm._s(_vm.entity.toWarehouse.name) + " ")]), _c("div", {
    staticClass: "transfer-contents-container"
  }, _vm._l(_vm.partsByWine, function (content) {
    return _c("div", {
      key: "transfer-content-" + content.wine.id,
      staticClass: "pb-2 mt-2 text-smaller"
    }, [_c("div", {
      staticClass: "text-bold"
    }, [_c("span", [_vm._v(" " + _vm._s(content.parts.reduce(function (acc, x) {
      return acc += x.quantity;
    }, 0)) + " x " + _vm._s(content.wine.displayName) + " ")]), _c("span", {
      staticClass: "text-smaller ml-2"
    }, [_vm._v(_vm._s(content.wine.naming_data.sku))]), _c("router-link", {
      staticClass: "router-link ml-2",
      attrs: {
        to: _vm.goToProduct(content.wine),
        target: "_blank"
      }
    }, [_c(VIcon, {
      staticClass: "fas fa-external-link-alt",
      staticStyle: {
        top: "-1px"
      },
      attrs: {
        size: "0.65rem"
      }
    })], 1)], 1), _c("div", _vm._l(content.parts, function (part) {
      var _part$fromPoData, _part$fromOrderData, _part$fromOrderData$i;
      return _c("div", {
        key: "transfer-content-part-" + part.id,
        staticClass: "pb-1 mt-1 text-smaller flex"
      }, [_vm.canCancelContent ? _c("div", [_c(VBtn, {
        staticClass: "dfwa-btn --small-2 secondary",
        attrs: {
          rounded: ""
        },
        on: {
          click: function click($event) {
            return _vm.confirmCancelContent(part);
          }
        }
      }, [_c(VIcon, {
        staticClass: "fa fa-times mr-1",
        attrs: {
          size: "0.65rem"
        }
      }), _vm._v(" Cancel ")], 1)], 1) : _vm._e(), _c("div", {
        class: [!_vm.canCancelContent ? "pl-6" : ""]
      }, [_vm._v(" " + _vm._s(part.quantity + "b. from ") + " "), ((_part$fromPoData = part.fromPoData) === null || _part$fromPoData === void 0 ? void 0 : _part$fromPoData.id) > 0 ? [_c("router-link", {
        staticClass: "router-link",
        attrs: {
          to: _vm.goToPurchaseOrder(part.fromPoData.id),
          target: "_blank"
        }
      }, [_vm._v(" " + _vm._s(part.fromPoData.reference ? "Po:".concat(part.fromPoData.reference) : "Po#".concat(part.fromPoData.id)) + " ")]), part.fromPoData.actualDeliveryDate ? _c("span", [_vm._v(" , Receipt:" + _vm._s(_vm._f("formatDate")(part.fromPoData.actualDeliveryDate)) + " ")]) : _vm._e()] : ((_part$fromOrderData = part.fromOrderData) === null || _part$fromOrderData === void 0 ? void 0 : _part$fromOrderData.id) > 0 ? [_c("router-link", {
        staticClass: "router-link",
        attrs: {
          to: _vm.goToOrder(part.fromOrderData.id),
          target: "_blank"
        }
      }, [_vm._v(" " + _vm._s((_part$fromOrderData$i = part.fromOrderData.invoiceNumberLabel) !== null && _part$fromOrderData$i !== void 0 ? _part$fromOrderData$i : part.fromOrderData.referenceOrder.shorterReference()) + " ")]), part.fromOrderData.deliveryDate ? _c("span", [_vm._v(" , Delivered:" + _vm._s(_vm._f("formatDate")(part.fromOrderData.deliveryDate)) + " ")]) : _vm._e()] : part.fromFirstInit ? [_vm._v("first initialisation")] : [_vm._v("manual adjustment")]], 2)]);
    }), 0)]);
  }), 0)]) : _vm._e(), _c("div", [_vm._v(" Comment "), _vm.isEditable && !_vm.isAnyActionInProgress && !_vm.isAnySubformInProgress ? _c(VIcon, {
    staticClass: "fa fa-pen icon-link ml-1",
    attrs: {
      size: "0.85em"
    },
    on: {
      click: _vm.startEditComment
    }
  }) : _vm._e(), _vm.isEditable && !_vm.isAnyActionInProgress && !_vm.isAnySubformInProgress && !!_vm.entity.comment ? _c(VIcon, {
    staticClass: "fa fa-ban icon-link ml-2",
    attrs: {
      size: "0.85em",
      title: "Remove comment"
    },
    on: {
      click: _vm.confirmRemoveComment
    }
  }) : _vm._e()], 1), !_vm.handlingComment.updating.isConfiguring ? [((_vm$entity$comment = _vm.entity.comment) === null || _vm$entity$comment === void 0 ? void 0 : _vm$entity$comment.length) > 0 ? _c("div", {
    staticClass: "text-quote text-bigger",
    domProps: {
      innerHTML: _vm._s(String.nl2br(_vm.entity.comment))
    }
  }) : _c("div", {
    staticClass: "text-italic"
  }, [_vm._v("No comment defined")])] : _vm._e(), _vm.handlingComment.updating.isConfiguring ? _c("div", [_c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.handlingComment.updating.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.handlingComment.updating.form, "valid", $$v);
      },
      expression: "handlingComment.updating.form.valid"
    }
  }, [_c(VTextarea, {
    attrs: {
      label: "Comment",
      rows: "3",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.handlingComment.updating.form.comment,
      callback: function callback($$v) {
        _vm.$set(_vm.handlingComment.updating.form, "comment", $$v);
      },
      expression: "handlingComment.updating.form.comment"
    }
  }), _c("div", {
    staticClass: "mt-3 flex"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: "",
      disabled: _vm.isAnyActionInProgress
    },
    on: {
      click: _vm.cancelUpdatingComment
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-times mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Cancel ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: "",
      disabled: _vm.isAnyActionInProgress || !_vm.handlingComment.updating.form.valid,
      loading: _vm.handlingComment.updating.isPending
    },
    on: {
      click: _vm.saveComment
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-save mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Save comment ")], 1)], 1)], 1)], 1) : _vm._e()], 2)] : _vm._e()], _c("div", {
    staticClass: "bloc-buttons-popin"
  }, [_vm.isCancellable ? _c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: true,
      disabled: _vm.isAnyActionInProgress || _vm.isAnySubformInProgress,
      loading: _vm.cancelling.isPending
    },
    on: {
      click: function click($event) {
        return _vm.confirmCancelling();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-times mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Cancel all transfer ")], 1) : _vm._e(), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: "",
      loading: _vm.exportingPdf.isPending
    },
    on: {
      click: _vm.exportPdf
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-download mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" PDF ")], 1), _vm.isEditable ? _c(VBtn, {
    staticClass: "dfwa-btn --small highlight",
    attrs: {
      rounded: true,
      disabled: _vm.isAnyActionInProgress || _vm.isAnySubformInProgress,
      loading: _vm.delivering.isPending
    },
    on: {
      click: function click($event) {
        return _vm.confirmDelivering();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-check mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Transfer done ")], 1) : _vm._e()], 1)], 2)], 1)], 1), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };